import * as d3 from "d3";
import dataUrl from 'url:./data.csv'

console.log("ran");

let theme = 0;
let slide = 0;
let setPoint;
let render;
let show = false;
d3.select("#crown").on("click", () => {
    document.documentElement.setAttribute('data-theme',['terminal','lemonade','popsicle','clean'][theme%4])
    theme += 1;
});


d3.csv(dataUrl).then(function(data) {

data = data.map(obj => {
    const {["Citation (Act.Scene.Line)"]:oldValue, ...rest} = obj;
    return {...rest,["Citation"]:oldValue};
});

const marginTop = 30;
const marginRight = 30;
const marginBottom = 80;
const marginLeft = 80;

const stars = [1,11,14,17,19,20,23,25,28,29,31,32,39,43,44,45,46,47,48,49];

const lineColor = "var(--main-color)";

let width;
let height;
let zoom;
let dx;
let gx
let x;
let path;
let line;
let labels;
let xAxis;
let svg;
let y;
render = () => {
// Declare the chart dimensions and margins.
width = parseInt(d3.select("#container").style("width"))//1000;
height = parseInt(d3.select("#container").style("height")) //600;

const extent = [[marginLeft, marginTop], [width - marginRight, height - marginTop]];

console.log(data);

// Declare the x (horizontal position) scale.
x = d3.scaleLinear()
    //.domain(data.map(quote => quote["Citation (Act.Scene.Line)"]))
    .domain([0,data.length - 1])
    .range([marginLeft, width - marginRight]);

dx = d3.scalePoint()
    //.domain(["Before","Act 1", "Act 2", "Act 3", "Act 4", "Act 5"])
    .domain(data.map(quote => quote["Citation"]))
    .range(x.range());

// Declare the y (vertical position) scale.
y = d3.scaleLinear()
    .domain([0, 11])
    .range([height - marginBottom, marginTop]);

line = (data, x) => d3.line()
    .x((d, i) => x(i))
    .y(d => y(d.Rankings))(data);

zoom = d3.zoom()
    .scaleExtent([1,25])
    .translateExtent(extent)
    .extent(extent)
    .on("zoom", zoomed);

// Create the SVG container.
svg = d3.create("svg")
//    .attr("width", width)
//    .attr("height", height)
    .attr("viewBox",[0,0,width,height])
  .attr("preserveAspectRatio", "none");

xAxis = (g,x) => g.call(d3.axisBottom(x).tickSizeOuter(0).tickFormat((d,i) => i==0?'':d))

// Add the x-axis.
gx = svg.append("g")
    .attr("class", "x-axis")
    .attr("stroke",lineColor)
    .attr("fill",lineColor)
    .attr("stroke-width",1)
    .style("font-size","16px")
    .attr("transform", `translate(0,${height - marginBottom})`).attr('clip-path', 'url(#clip-path)')
    .call(xAxis,dx);

gx.selectAll("text")
    .attr("dx","1em")
    .attr("dy","-0.5em")
    .attr("text-anchor","start")
    .attr("fill",lineColor)
    .attr("stroke-width",0.5)
    .attr("transform",'rotate(90)');

// Add the y-axis.
svg.append("g")
    .attr("transform", `translate(${marginLeft},0)`)
    .attr("stroke",lineColor)
    .style("font-size","24px")
    .call(d3.axisLeft(y).tickFormat((d,i) => i==11?'Dead':d))
    .selectAll("text")
    .attr("fill",lineColor)
    .attr("stroke-width",0.5);



svg.append('defs')
    .append('clipPath')
    .attr('id', 'clip-path')
    .append('rect')
    .attr('x', marginLeft) // Clip from the left of the SVG
    .attr('y', 0)
    .attr('width', width) // Clip to the entire width of the SVG
    .attr('height', height);

path = svg.append("path")
    .attr("class", "path")
    .attr("fill", "none")
    .attr("stroke", lineColor)
    .attr("stroke-width", 1.5)
    .attr("d", line(data, x))
    .attr('clip-path', 'url(#clip-path)');

labels = svg.append("g")
    .selectAll()
    .data(data)
    .enter()
    .append("text")
    .attr("x", (d,i) => x(i))
    .attr("y", d => y(d.Rankings))
    .attr("dy","-1ex")
    .attr("dx","")
    .attr("fill",lineColor)
    .attr("stroke","var(--container)")
    .attr("stroke-linecap","round")
    .attr("stroke-linejoin","round")
    .attr("stroke-width",3)
    .attr("paint-order","stroke")
    .style("text-anchor","middle")
    .attr("font-size","20px")
    .text((d,i) => i!=0?i:'')
    .attr('clip-path', 'url(#clip-path)');

svg.append("g")
    .attr('clip-path', 'url(#clip-path)')
    .attr("stroke-width", 1.5)
    .attr("font-family", "sans-serif")
    .attr("font-size", 10)
    .attr("class","icons")
    .selectAll("path")
    .data(data)
    .join("path")
    .attr("transform", (d,i) => `translate(${x(i)},${y(d.Rankings)})`)
    .attr("fill",lineColor)
    .attr("stroke-width",2)
    .attr("stroke","var(--container)")
    .attr("paint-order","stroke")
    .attr("id",(d,i) => "icon_" + i)
    .attr("class","icon")
    .attr("d", (d,i) => {return d3.symbol().type(stars.includes(i)?d3.symbolStar:d3.symbolCircle).size(40)()})
    .on("mousemove",mousemoved);


container.replaceChildren(svg.node());// Declare the chart dimensions and margins
svg.call(zoom).call(zoom.transform,d3.zoomIdentity);
} // Close render function



//https://github.com/d3/d3-zoom/issues/57
function setZoom(start,end) {
    d3.selectAll("button").style("text-decoration-line","none")
    const scale = (width-marginLeft-marginRight) / (x(end) - x(start) + (end==(data.length-1)?5:0))
    svg.transition().duration(500).call(zoom.transform, d3.zoomIdentity
    .scale(scale)
    .translate(-x(start)+(end==(data.length-1)?5:0)+marginLeft/(scale)+(start?(end==(data.length-1)?0:10):0), 0)) 
}

function zoomed(event) {
    const transform = event.transform;
    if (event.sourceEvent) {
        d3.selectAll("button").style("text-decoration-line","none")
    }
    dx.range([marginLeft, width - marginRight].map(d => transform.applyX(d)));
    const xz = transform.rescaleX(x);
    path.attr("d",line(data,xz));
    labels.attr("x", (d,i) => xz(i));
    gx.call(xAxis,dx);
    svg.selectAll(".icon").attr("transform", (d,i) => `translate(${xz(i)},${y(d.Rankings)})`)
};

function resetUnderlines() {
    d3.selectAll("button").style("text-decoration-line","none")
}



let current = 1;

function mousemoved(event,d) {
    current = data.indexOf(d);
    d3.selectAll(".icon").attr("d", (d,i) => {return d3.symbol().type(stars.includes(i)?d3.symbolStar:d3.symbolCircle).size(80)()})
    d3.select("#icon_"+data.indexOf(d)).attr("d",d3.symbol().type(stars.includes(data.indexOf(d))?d3.symbolStar:d3.symbolCircle).size(180)());
    quote_number.innerHTML = data.indexOf(d);
    character.innerHTML = d.Character[0] + d.Character.toLowerCase().slice(1);
    character.insertAdjacentHTML("beforeend"," (<a class='text-[var(--main-color)] border-dotted hover:border-solid border-b' target='_blank' href='https://www.folger.edu/explore/shakespeares-works/hamlet/read/#line-"+d.Link+"'>"+d["Citation"]+"</a>)");
    commentary_text.innerHTML = d.Commentary;
    quote_text.innerHTML = d.Quote;
    d_total.innerHTML = d.Rankings
    d_hamlet.innerHTML = d.Hamlet;
    d_proximity.innerHTML = d.Proximity;
    d_other.innerHTML = d.Other;
}

d3.select("body").on("keydown", ({keyCode}) => {
    console.log(keyCode)
    if (keyCode == 39) {
        current = Math.min(data.length-1,current+1);
    } 
    if (keyCode == 37) {
        current = Math.max(0, current-1);
    }
    if (keyCode == 37 | keyCode == 39) {
        mousemoved(null,data[current])
    }
    if (keyCode == 32 && show) {
        slide += 1;
        showSlide()
    }
    if (keyCode == 66 && show) {
        slide = Math.max(0,slide-1);
        showSlide()
    }
    if (keyCode == 82 && show) {
        showSlide()
    }
});

d3.select("#full_play").on("click", () => {svg.transition().duration(300).call(zoom.transform,d3.zoomIdentity);resetUnderlines();d3.select("#full_play").style("text-decoration-line","underline")});
d3.select("#act_1").on("click", () => {setZoom(0,17);d3.select("#act_1").style("text-decoration-line","underline")});
d3.select("#act_2").on("click", () => {setZoom(18,24);d3.select("#act_2").style("text-decoration-line","underline")});
d3.select("#act_3").on("click", () => {setZoom(24,37);d3.select("#act_3").style("text-decoration-line","underline")});
d3.select("#act_4").on("click", () => {setZoom(37,46);d3.select("#act_4").style("text-decoration-line","underline")});
d3.select("#act_5").on("click", () => {setZoom(46,data.length-1);d3.select("#act_5").style("text-decoration-line","underline")});



render()

d3.select(window).on('resize',render)
/*
d3.select(window).on('resize', resize);

function resize() {
    const nwidth = parseInt(d3.select("#container").style("width"))//1000;
    const nheight = parseInt(d3.select("#container").style("height")) //600;
    svg.attr("width", nwidth)
    .attr("height", nheight)
    .attr("viewBox",[0,0,nwidth,nheight]);
    console.log("resized")
 
}

*/
mousemoved(null, data[1]);

setPoint = (number) => {
    console.log("set",number)
    current = number;
    mousemoved(null,data[current])
}

});

overlay.style.display = 'none';

const presentation = [{show:[overlay,slide_title],hide:[thesis,guide_question,intro]},{show:[intro,overlay],hide:[slide_title,guide_question,thesis]},{show:[intro,thesis,overlay],hide:[guide_question]},{show:[intro,thesis,guide_question,overlay]},{point:0,hide:[overlay,intro,thesis,guide_question]},{point:1,button:[act_1]},{point:11,button:[act_1]},{point:14,button:[act_1]},{point:17,button:[act_1]},{point:19,button:[act_2]},{point:20,button:[act_2]},{point:23,button:[act_2]},{point:25,button:[act_3]},{point:28,button:[act_3]},{point:29,button:[act_3]},{point:31,button:[act_3]},{point:32,button:[act_3]},{point:39,button:[act_4]},{point:43,button:[act_4]},{point:44,button:[act_4]},{point:45,button:[act_4]},{point:46,button:[act_5]},{point:47,button:[act_5]},{point:48,button:[act_5]},{point:49,button:[act_5]},{button:[full_play]}];

function showSlide() {
    if (slide == 0) {
        document.documentElement.requestFullscreen();
    }
    const state = presentation[slide];
    state?.show?.forEach((e) => {e.style.display = 'initial'});
    state?.hide?.forEach((e) => {e.style.display = 'none'});
    if (state?.point != undefined) {setPoint(state.point)};
    state?.button?.forEach((e) => {e.click();});
}

d3.select("#sword").on("click", () => {if(!show){showSlide()};show=!show})
